import { AfterViewInit, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Reservation } from "src/app/models/reservation-model";
import { Studio } from "src/app/models/studio-model";
import { User } from "src/app/models/user-model";
import { AuthService } from "src/app/services/auth/auth.service";
import { CustomService } from "src/app/services/custom/custom.service";
import { DateFormatterService } from "src/app/services/date-formatter/date-formatter.service";
import { DefaultService } from "src/app/services/default/default.service";
import { GenerateErrors } from "src/app/utils/generate-errors";
import { Webflow } from "src/app/utils/webflow";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit, AfterViewInit {
  status: any = {
    "canceled": { text: "Annulé", class: "badge badge-danger" },
    "pending": { text: "En attente", class: "badge badge-warning" },
    "waiting-confirmation": { text: "En attente de confirmation", class: "badge badge-primary" },
    "confirmed": { text: "Confirmé", class: "badge badge-success" },
    "failed": { text: "Échoué", class: "badge badge-danger" },
  };
  is_connected: boolean = null;

  count_studios: number = 0;
  count_requested_booking: number = 0;
  count_accepted_booking: number = 0;
  studios: Array<Studio> = [];
  reservations: Array<Reservation> = [];

  loading: boolean = true;
  currentUser: User | null = null;

  constructor(
    private customService: CustomService,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private defaultService: DefaultService,
    private dateFormatterService: DateFormatterService
  ) { }

  ngOnInit(): void {
    this.authService.currentUser.subscribe((user) => {
      this.currentUser = user;
      this.is_connected = user != null;
    });

    if (this.is_connected) {
      this.get_dashboard();
    } else {
      Webflow.setIFrameHeight();
    }
  }

  ngAfterViewInit(): void {
    Webflow.setIFrameHeight();
  }

  get_dashboard() {
    this.count_studios = 0;
    this.count_requested_booking = 0;
    this.count_accepted_booking = 0;
    this.studios = [];
    this.reservations = [];
    this.spinner.show();
    this.customService
      .dashboard()
      .subscribe((res) => {
        this.count_studios = res.count_studios;
        this.count_requested_booking = res.count_requested_booking;
        this.count_accepted_booking = res.count_accepted_booking;
        this.studios = res.list_studios.map(
          (studio) => new Studio(Studio.responseToJson(studio))
        );
        this.reservations = res.list_bookings.map(
          (reservation) =>
            new Reservation(Reservation.responseToJson(reservation))
        );
      })
      .add(() => {
        setTimeout(() => {
          this.spinner.hide();
          this.loading = false;
          Webflow.setIFrameHeight();
        }, 500);
      });
  }

  annuler(reservation: Reservation) {
    Webflow.setIFrameHeight();
    Swal.fire({
      title: "Annuler la réservation",
      text: "Étes-vous sûre de vouloir annulée la réservation ?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: `Confirmer`,
      cancelButtonText: `Annuler`,
      position: "top",
      cancelButtonColor: "black",
      confirmButtonColor: "#D63333",
    }).then((result) => {
      if (result.isConfirmed) {
        this.defaultService
          .post("reservations/" + reservation.id + "/manager/cancel", {})
          .subscribe(
            (res) => {
              Swal.fire({
                title: "Félicitation",
                text: "La réservation a été annulée avec succès",
                icon: "success",
                position: "top",
              });
              // this.get_dashboard();
            },
            (error) => {
              if (GenerateErrors.check_if_is_custom_error(error)) {
                Swal.fire({
                  title: "Érreur",
                  text: GenerateErrors.get_message_error(error),
                  icon: "error",
                  position: "top",
                });
              } else {
                Swal.fire({
                  title: "Érreur",
                  text: "Une érreur est survenue",
                  icon: "error",
                  position: "top",
                });
              }
            }
          );
      }
    });
  }

  redirectToWebflow(slug: string) {
    const baseUrl = environment.webflow_url;
    return `${baseUrl}${slug}`;
  }

  date_format(date: any) {
    return this.dateFormatterService.showDateHour(date);
  }

  navigateTo(actionName: string) {
    Webflow.myAction(this.router,actionName, {});
  }
}
